import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { usePageMeta } from '@/hooks/usePageMeta';

export default function Impressum() {
  usePageMeta({ noIndex: true });

  return (
    <main className="font-sans bg-white min-h-screen">
      <Navbar />

      <div className="max-w-3xl mx-auto px-4 md:px-8 pt-32 pb-20">

        {/* Back link */}
        <Link
          to="/"
          className="inline-flex items-center gap-1.5 text-sm text-charcoal/50 hover:text-rose transition-colors duration-200 cursor-pointer mb-10"
        >
          <span className="w-4 h-4 flex items-center justify-center">
            <i className="ri-arrow-left-line text-sm" />
          </span>
          Zurück zur Startseite
        </Link>

        <h1 className="font-serif text-4xl md:text-5xl font-medium text-charcoal mb-2">
          Impressum
        </h1>
        <p className="font-sans text-sm text-charcoal/40 mb-10">
          Angaben gemäß § 5 TMG
        </p>

        <div className="prose-custom space-y-10 text-charcoal">

          {/* Anbieter */}
          <section>
            <h2 className="font-sans text-lg font-semibold text-charcoal mb-3">
              Angaben zur Person / Unternehmerin
            </h2>
            <div className="font-sans text-base text-charcoal/80 leading-[1.9] space-y-0.5">
              <p><strong>Jenny [Nachname]</strong></p>
              <p>Flow &amp; Glow</p>
              <p>Kosmetische Zahnaufhellung</p>
              <p>[Straße und Hausnummer] <span className="text-charcoal/40 text-sm">[folgt]</span></p>
              <p>[PLZ] Köln <span className="text-charcoal/40 text-sm">[folgt]</span></p>
              <p>Deutschland</p>
            </div>
          </section>

          <div className="border-t border-charcoal/8" />

          {/* Kontakt */}
          <section>
            <h2 className="font-sans text-lg font-semibold text-charcoal mb-3">
              Kontakt
            </h2>
            <div className="font-sans text-base text-charcoal/80 leading-[1.9] space-y-0.5">
              <p>
                Telefon:{' '}
                <span className="text-charcoal/40 text-sm">[Nummer folgt]</span>
              </p>
              <p>
                E-Mail:{' '}
                <a
                  href="mailto:hallo@flowundglow.de"
                  className="text-rose hover:underline cursor-pointer"
                >
                  hallo@flowundglow.de
                </a>
              </p>
            </div>
          </section>

          <div className="border-t border-charcoal/8" />

          {/* Steuer */}
          <section>
            <h2 className="font-sans text-lg font-semibold text-charcoal mb-3">
              Umsatzsteuer-Identifikationsnummer
            </h2>
            <p className="font-sans text-base text-charcoal/80 leading-[1.9]">
              USt-IdNr. gemäß § 27a UStG:{' '}
              <span className="text-charcoal/40 text-sm">[folgt nach Zuteilung durch das Finanzamt]</span>
            </p>
          </section>

          <div className="border-t border-charcoal/8" />

          {/* Berufsrecht */}
          <section>
            <h2 className="font-sans text-lg font-semibold text-charcoal mb-3">
              Berufsrechtliche Angaben
            </h2>
            <div className="font-sans text-base text-charcoal/80 leading-[1.9] space-y-2">
              <p>
                Flow &amp; Glow bietet kosmetische Zahnaufhellung gemäß der
                EU-Kosmetikverordnung (EG) Nr. 1223/2009 an. Die eingesetzten
                Produkte sind peroxidfrei und enthalten ausschließlich zugelassene
                Wirkstoffe (PAP-Technologie). Es handelt sich ausdrücklich{' '}
                <strong>nicht</strong> um eine zahnärztliche oder medizinische
                Behandlung.
              </p>
              <p>
                Inhaberin: Jenny [Nachname], Zahnmedizinische
                Prophylaxe-Assistentin (ZMP)
              </p>
            </div>
          </section>

          <div className="border-t border-charcoal/8" />

          {/* Haftung Inhalte */}
          <section>
            <h2 className="font-sans text-lg font-semibold text-charcoal mb-3">
              Haftung für Inhalte
            </h2>
            <p className="font-sans text-base text-charcoal/80 leading-[1.9]">
              Als Dienstanbieterin bin ich gemäß § 7 Abs. 1 TMG für eigene Inhalte
              auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach
              §§ 8 bis 10 TMG bin ich als Dienstanbieterin jedoch nicht
              verpflichtet, übermittelte oder gespeicherte fremde Informationen zu
              überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige
              Tätigkeit hinweisen. Verpflichtungen zur Entfernung oder Sperrung der
              Nutzung von Informationen nach den allgemeinen Gesetzen bleiben
              hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem
              Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich.
            </p>
          </section>

          <div className="border-t border-charcoal/8" />

          {/* Haftung Links */}
          <section>
            <h2 className="font-sans text-lg font-semibold text-charcoal mb-3">
              Haftung für Links
            </h2>
            <p className="font-sans text-base text-charcoal/80 leading-[1.9]">
              Mein Angebot enthält Links zu externen Websites Dritter, auf deren
              Inhalte ich keinen Einfluss habe. Deshalb kann ich für diese fremden
              Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten
              Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten
              verantwortlich. Rechtswidrige Inhalte waren zum Zeitpunkt der
              Verlinkung nicht erkennbar.
            </p>
          </section>

          <div className="border-t border-charcoal/8" />

          {/* Urheberrecht */}
          <section>
            <h2 className="font-sans text-lg font-semibold text-charcoal mb-3">
              Urheberrecht
            </h2>
            <p className="font-sans text-base text-charcoal/80 leading-[1.9]">
              Die durch die Seitenbetreiberin erstellten Inhalte und Werke auf
              diesen Seiten unterliegen dem deutschen Urheberrecht. Die
              Vervielfältigung, Bearbeitung, Verbreitung und jede Art der
              Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der
              schriftlichen Zustimmung der jeweiligen Autorin. Downloads und Kopien
              dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch
              gestattet.
            </p>
          </section>

          <div className="border-t border-charcoal/8" />

          <p className="font-sans text-xs text-charcoal/35 pt-2">
            Stand: April 2026
          </p>
        </div>
      </div>

      <Footer />
    </main>
  );
}
